<template>
    <div>
        <div class="widget-inner d-flex flex-wrap">
            <template v-for="propGroup in currentVariation.variationProperties">
                <template v-for="prop in  propGroup.properties">
                    <template v-if="splitProps.includes(prop.id.toString())">   
                        <template v-if="prop.values">
                            <div class="propContainer">
                                <template v-if="prop.cast == 'text'">
                                    <div class="textProperty propWrapper textProp">
                                        <template v-if="prop.names.description.length > 0">
                                            <div class="iconWrapper">
                                                <img  class="propIcon img-fluid"  :src="prop.names.description" :alt="prop.names.name" :title="prop.names.name"  >
                                            </div>
                                        </template>
                                        <div class="textWrapper">
                                            <span>
                                                {{ prop.values.value }}
                                                <template v-if="prop.id == 71 || prop.id == 86 ">
                                                    mm
                                                </template>
                                            </span>
                                        </div>

                                    </div>
                                </template>
                                <template v-else-if="prop.cast == 'int'">
                                    <div class="numberProperty propWrapper intProp">
                                        <template v-if="prop.names.description.length > 0">
                                            <div class="iconWrapper">
                                                <img  class="propIcon img-fluid"  :src="prop.names.description" :alt="prop.names.name" :title="prop.names.name"  >
                                            </div>
                                        </template>
                                        <div class="textWrapper">
                                            <span>
                                                {{ prop.values.value }}
                                                <template v-if="prop.options.units[0] == 'GRM'">
                                                    g
                                                </template>
                                                <template v-else>
                                                    {{ prop.options.units[0]}}
                                                </template>
                                            </span>
                                        </div>
                                    </div>
                                </template>
                                <template v-else-if="prop.cast == 'selection'">
                                    <div class="iconProperty propWrapper selectionProp">
                                        <template v-if="prop.values.description.length > 0">
                                            <div class="iconWrapper">
                                                <img class="propIcon img-fluid"  :src="prop.values.description" :alt="prop.values.value" :title="prop.values.value"  >
                                            </div>
                                        </template>
                                        <div class="textWrapper">
                                            <span>
                                                {{ prop.values.value }}
                                            </span>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="iconProperty propWrapper  " :class="{'openInfoModal': prop.id == 87 && $translate('CeresCoconut::Template.itemVarPropModalText87').length > 0 }" :data-modaltitle="'modalTitleVP' + prop.id " :data-modaltext="'modalTextVP' + prop.id">
                                        <template v-if="prop.names.description.length > 0">
                                            <div class="iconWrapper">
                                                <img class="propIcon img-fluid"  :src="prop.names.description" :alt="prop.names.name" :title="prop.names.name"  >
                                                <span class="propInfo" v-if="prop.id == 87 && $translate('CeresCoconut::Template.itemVarPropModalText87').length > 0">                                                    
                                                    <lazy-img ref="itemLazyImage" picture-class=""  image-url=" https://cdn02.plentymarkets.com/4tnz2nlw17zy/frontend/Icons/Kosmetikspiegel_Attributeinfo.svg" :alt="prop.values.values" :title="prop.values.values"  ></lazy-img>                                                                                                     
                                                </span>
                                            </div> 
                                        </template>
                                        <div class="textWrapper"> 
                                            <span>
                                                {{ prop.names.name }}
                                            </span>
                                        </div> 
                                        <template v-if="prop.id == 87">
                                            <template v-if="$translate('CeresCoconut::Template.itemVarPropModalText87').length > 0 ">
                                                <div class="attribueInfoContent">
                                                    <span :class="'modalTitleVP' + prop.id">
                                                        {{ $translate('CeresCoconut::Template.itemVarPropModalHeading87') }}
                                                    </span>
                                                    <p :class="'modalTextVP' + prop.id">
                                                        {{ $translate('CeresCoconut::Template.itemVarPropModalText87') }}
                                                    </p>
                                                </div>      
                                            </template>
                                        </template>                            
                                    </div>
                                </template>                        
                            </div>
                        </template>
                    </template>
                </template>
            </template>
        </div>
    </div>
</template>


<script>
export default {
    name: "item-icon-properties",    
     props:
    {
        iconProperties:
        {
            type: String,
            default: ""
        }
    },
    inject: {
        itemId: {
            default: null
        }
    },

    computed:
    {        
         currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`]
        },
        splitProps(){
            return this.iconProperties.split(",");
        }
    }
}
</script>
